<template>
  <div class="content">
    <!--列表-->
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item
          v-if="this.where.seriesid"
          :to="{ path: 'car-brand' }"
          >品牌管理</el-breadcrumb-item
        >
        <el-breadcrumb-item
          v-if="this.where.seriesid"
          :to="{
            path: 'car-series',
            query: { show: 'true', seriesid: this.where.seriesid },
          }"
          >车系管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>车友口碑</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row type="flex" :gutter="20">
        <el-col
          :span="1"
          v-if="$utils.checkPer('car-score.store')"
          style="margin-right: 10px"
        >
          <el-button style="float: left" type="primary" @click="addData" size="mini"
            >新增</el-button
          >
        </el-col>
        <el-col :span="3">
          <el-select
            v-model="where.score_type"
            clearable
            placeholder="请选择积分类别"
            size="mini"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-input
            v-model="where.title"
            style="width: 200px"
            placeholder="标题"
            clearable
            size="mini"
          ></el-input>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="index(where)" size="mini">查询</el-button>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-table v-loading="loading" border :data="tableData" height="650" style="margin-bottom:5px">
          <el-table-column type="index" fixed label="序号" align="center">
          </el-table-column>
          <el-table-column
            prop="get_car_user.name"
            label="用户名"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="title" label="标题" align="center">
          </el-table-column>
          <el-table-column
            prop="get_series.series_name"
            label="所属车系"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="content"
            align="center"
            label="内容"
            width="150"
          >
            <template slot-scope="scope">
              <el-tag>{{ scope.row.content.substring(0, 10) + "..." }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="score_num" align="center" label="评分">
          </el-table-column>
          <el-table-column prop="score_type" align="center" label="类型">
          </el-table-column>
          <el-table-column prop="review_type" align="center" label="审核状态">
            <template slot-scope="scope">
              <span>{{ scope.row.review_type ? "已审核" : "未审核 " }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                v-if="$utils.checkPer('car-score.store')"
                @click="editMessage(scope.row)"
                type="primary" 
                plain
                >修改</el-button
              >
              <el-button
                size="small"
                v-if="$utils.checkPer('car-score.store')"
                @click="delMessage(scope.row)"
                type="danger"
                plain
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="index(where)"
          :current-page.sync="where.page"
          :page-size="where.pagesize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </el-row>
    </div>
    <!-- 添加 -->
    <el-dialog
      title="车友口碑"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      v-if="dialogVisible"
    >
      <myForm
        @emitcarscor="onemitcarscor"
        :row="updataList"
        :edit="isupdata"
      ></myForm>
    </el-dialog>
  </div>
</template>

<script>
import myForm from "./form";

import {
  car_score,
  addcar_score,
  modifycar_score,
  delcar_score,
} from "../../api/api";
export default {
  name: "car-score",
  props: {
    seriesid: Number,
  },
  components: { myForm },
  data() {
    return {
      tableData: [],
      loading: false,
      where: {
        seriesid: "",
        score_name: "",
        score_type: "",
        page: 1,
        pagesize: 10,
      },
      total: 0,
      options: [
        {
          value: "0",
          label: "用户评分",
        },
        {
          value: "1",
          label: "专家评分",
        },
        {
          value: "2",
          label: "安全评分",
        },
        {
          value: "3",
          label: "常见问题",
        },
      ],
      dialogVisible: false,
      isupdataid: 0,
      updataList: "",
      isupdata: false,
    };
  },
  mounted() {
    this.where.seriesid = this.$route.query.seriesid;
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      car_score(this.where).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data).data;
        this.total = data.total;
        this.tableData = data.data;
        this.loading = false;
      });
    },
    addData() {
      this.dialogVisible = true;
    },
    onemitcarscor(obj) {
      if (obj.form) {
        if (this.isupdata == false) {
          addcar_score(obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
              this.getList();
            } else {
              this.$message.error(data.msg);
            }
          });
        }
        if (this.isupdata == true) {
          modifycar_score(this.isupdataid, obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
              this.getList();
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      } else {
        console.log("取消");
      }
      this.dialogVisible = false;
      this.isupdataid = 0;
      this.updataList = "";
      this.isupdata = false;
      
    },
    editMessage(scope) {
      console.log("数据",scope)
      this.dialogVisible = true;
      this.isupdataid = scope.id;
      this.updataList = scope;
      this.isupdata = true;
    },
    delMessage(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delcar_score(row.id).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
              this.getList();
            } else {
              this.$message.error(data.msg);
            }
          });
          
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.where.pagesize = val;
      this.getList();
    },
    index(e) {
      this.where = e;
      this.getList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
  filters: {
    getImg: function (value) {
      if (value == "[]") return "";
      let res = JSON.parse(value);
      let url = window.location.origin + "/" + res[0].response.path;
      return url;
    },
    getText: function (value) {
      if (!value || value == "") return "";
      let res_json = JSON.parse(value);
      let res = "";
      for (var i = 0; i < res_json.length; i++) {
        res += res_json[i] + "\n";
      }
      return res;
    },
  },
};
</script>

<style scoped lang="scss">
.el-col-3 {
  width: 210px;
}
.el-col-1 {
  width: 68px;
}
.el-breadcrumb {
  margin-bottom: 15px;
}
</style>
